/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'react-bootstrap';
import { useCareLabelState } from '../context/index';
import { useComponent } from '../../../UserSetting/UsersLibrary/UserRights';
import '../CareLabel.css';
import Loader from '../../../../Components/Utility/Loader/Loader';
import { checkArray } from '../../../../Components/helper';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import * as action from '../store/CareLabel.action';
import * as userAction from '../../../UserSetting/store/User.action';
import GroupCard from './GroupCard';

function List() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { careLabelState, userInfo, getCareGroupData } = useCareLabelState();
  const { pageType, CareGroupData, pageLoader, imgPath } = careLabelState;
  const reducerState = useSelector((redState) => redState);
  const { Users } = reducerState;
  const { logInRights } = Users;
  const [state, setState] = useState({
    deleteModal: false,
    selectedGroup: [],
  });
  const { deleteModal, selectedGroup } = state;
  const { CheckActionPermission } = useComponent();
  const CareAddEditAccess = CheckActionPermission(logInRights, 'libraries', 'care', 'addEdit');
  const CareDeleteAccess = CheckActionPermission(logInRights, 'libraries', 'care', 'delete');
  const { t } = useTranslation('common');
  const isallChecked = checkArray(CareGroupData) && selectedGroup.length === CareGroupData.length;

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    if (user?.role === 'User') {
      dispatch(userAction.fetchLogInRights({ section: 'all' }));
    }
  }, []);

  const handleDelete = (delId) => {
    setState((prevState) => ({
      ...prevState,
      deleteModal: true,
      selectedGroup: [delId],
    }));
  };
  const handleCloseDeleteModal = () => {
    setState((prevState) => ({
      ...prevState,
      deleteModal: false,
      selectedGroup: [],
    }));
  };

  const confirmDelete = async () => {
    const delObj = {
      groupIds: JSON.stringify(selectedGroup),
      loggedInUserId: userInfo?.userId,
    };

    const response = await dispatch(action.deleteCareGroup(delObj, t));
    if (response.code === 200) {
      getCareGroupData();
      handleCloseDeleteModal();
    }
  };

  const handleCheckAll = async (e) => {
    if (e.target.checked) {
      const allIds = CareGroupData && checkArray(CareGroupData) && CareGroupData.map((ele) => ele._id);

      if (allIds) {
        setState((prevState) => ({
          ...prevState,
          selectedGroup: allIds.filter((element) => element !== undefined),
        }));
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        selectedGroup: [],
      }));
    }
  };

  const handleCheckGroup = async (isGrpChecked, grpId) => {
    const existingIds = selectedGroup;

    if (isGrpChecked && !existingIds?.includes(grpId)) {
      setState((prevState) => ({
        ...prevState,
        selectedGroup: [...existingIds, grpId],
      }));
    } else {
      const removedArray = existingIds?.filter((eleId) => eleId !== grpId);
      if (checkArray(removedArray)) {
        setState((prevState) => ({
          ...prevState,
          selectedGroup: removedArray,
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          selectedGroup: [],
        }));
      }
    }
  };

  const handleDeleteMultiple = () => {
    setState((prevState) => ({
      ...prevState,
      deleteModal: true,
    }));
  };

  const handleAddCareGroup = () => {
    history.push('/libraries/care-group/add');
  };
  const handleSearchText = (inputText) => {
    getCareGroupData(inputText);
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">{t('CARE_LABELS.GROUP.CARE_LIST.CARE_LABEL_GROUP')}</h4>
        </div>
        <div className="search-filter group-filter">
          <div className="product-list-search">
            <div className="form w-100">
              <input
                type="text"
                // value={searchText}
                onChange={(e) => handleSearchText(e.target.value)}
                className="form-control"
                placeholder={t('CARE_LABELS.GROUP.CARE_LIST.SEARCH_CARE_LABEL')}
              />
            </div>
          </div>
          {CareAddEditAccess && (
            <button type="button" onClick={() => handleAddCareGroup()} title={t('CARE_LABELS.GROUP.CARE_LIST.ADD')} className="filter-btn filter-button_add">
              <i className="icon-add" />
            </button>
          )}
          {CareDeleteAccess && (
            <>
              <button
                type="button"
                title={t('CARE_LABELS.GROUP.CARE_LIST.DELETE_SELECTED')}
                disabled={!checkArray(selectedGroup)}
                onClick={() => handleDeleteMultiple()}
                className="filter-btn filter-button_add"
              >
                <i className="icon-delete" />
              </button>
              <div className="selectall-checkbox">
                <input type="checkbox" name="selectAll" id="selectAll" onChange={(e) => handleCheckAll(e)} checked={isallChecked} />
                <label htmlFor="selectAll" className="btn btn-white btn-back-lib mb-0">
                  <span>
                    {isallChecked ? 'Unselect' : 'Select'} {t('CARE_LABELS.GROUP.CARE_LIST.ALL')}
                  </span>
                </label>
              </div>
            </>
          )}
        </div>
      </div>
      <Container fluid>
        <div className="tabs-container border-0 mb-5">
          <div className="tab-right">
            <Link className={`${pageType === 'Library' && 'active'} btn btn-default text-dark text-decoration-none mr-2`} to="/libraries/care/symbol">
              {t('CARE_LABELS.GROUP.CARE_LIST.CARE_LABEL_LIBRARY')}
            </Link>
            <Link className={`${pageType === 'Group' && 'active'} btn btn-default text-dark text-decoration-none`} to="/libraries/care-group">
              {t('CARE_LABELS.GROUP.CARE_LIST.CARE_LABEL_GROUPS')}
            </Link>
          </div>
        </div>
        {pageLoader ? (
          <Loader />
        ) : (
          <Row>
            {checkArray(CareGroupData) ? (
              CareGroupData.map((eleGrp, i) => {
                return (
                  <Col key={eleGrp?._id} md={3}>
                    <GroupCard
                      eleGrp={eleGrp}
                      index={i}
                      imgPath={imgPath}
                      handleCheckGroup={handleCheckGroup}
                      selectedGroup={selectedGroup}
                      handleDelete={handleDelete}
                      CareAddEditAccess={CareAddEditAccess}
                      CareDeleteAccess={CareDeleteAccess}
                    />
                  </Col>
                );
              })
            ) : (
              <Col md={12}>
                <p className="text-center">{t('CARE_LABELS.GROUP.CARE_LIST.NO_LABEL_GROUP_FOUND')}</p>
              </Col>
            )}
          </Row>
        )}
      </Container>
      {deleteModal && (
        <ConfirmationPopup
          onOpen={deleteModal}
          onConfirm={() => confirmDelete()}
          title={t('CARE_LABELS.GROUP.CARE_LIST.DELETE_CARE_LABEL_GROUP')}
          message={t('CARE_LABELS.GROUP.CARE_LIST.LABEL_GROUP_MESSAGE')}
          toggle={() => handleCloseDeleteModal()}
        />
      )}
    </>
  );
}

export default List;
